import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { Oval } from "react-loader-spinner";
import ProjectCard from "./ProjectCard";

const Projects = () => {
  // const [projectList, setProjectList] = useState([]);
  // const [loader, setLoader] = useState(false)
  // useEffect(() => {
  //   fetch("https://portfolio-server-sage.vercel.app/projects")
  //     .then((res) => res.json())
  //     .then((data) => setProjectList(data));
  // }, []);

  const {data : projectList = [], isLoading} = useQuery({
    queryKey : ['projectList'],
    queryFn : async() => {
      const res = await fetch("https://portfolio-server-sage.vercel.app/projects")
      const data = await res.json()
      return data;
    }
  })

  if(isLoading){
    return <div className="flex justify-center py-20">
      <Oval
    height={80}
    width={80}
    color="#4fa94d"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
    ariaLabel='oval-loading'
    secondaryColor="#4fa94d"
    strokeWidth={2}
    strokeWidthSecondary={2}
  
  />
    </div>
  }

  return (
    <div id="projects">
      <h1 className="text-5xl lg:text-6xl font-bold text-center mb-8 lg:mb-16">
        Projects
      </h1>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {projectList.map((project) => (
          <ProjectCard project={project} isLoading={isLoading} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
